module.exports = __webpack_public_path__ + "static/assets/8726263c2a7d24e22ecc662ed3ac70eb.png";